import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    FETCH() {
      return this.get(links.MAJORITY_FETCH(), {
        dataKey: "hydra:member",
      });
    },
    QUERY_FETCH(agencyId, queryParams) {
      // NOTE: prepare query params
      var processedQueryParams = {};
      // filters
      queryParams.filter.forEach(filter => {
        processedQueryParams[filter.column] = filter.value;
      });
      // order
      if (queryParams && queryParams.sort) {
        processedQueryParams[`order[${queryParams.sort.by}]`] = queryParams.sort.dir.toLowerCase();
      }

      // page
      processedQueryParams.page = queryParams.page;
      processedQueryParams.itemsPerPage = queryParams.itemsPerPage;
      return this.get(links.MAJORITY_QUERY_FETCH(), {
        params: processedQueryParams,
        paramsSerializer: params => {
          return qs.stringify(params);
        },
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.MAJORITY_GET(id));
    },
    POST(item) {
      return this.post(links.MAJORITY_POST(), item);
    },
    PUT(item) {
      return this.put(links.MAJORITY_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.MAJORITY_DELETE(item.id), {
        delete: item.id,
      });
    },
    REGISTER_GET_MAJORITIES(meetingId) {
      let params = {};
      if (meetingId) {
        params["meeting_id"] = meetingId;
      }
      return this.get(links.MAJORITY_QUERY_FETCH() + "/meeting_register?" + qs.stringify(params));
    },
    CUSTOM_UPDATE(item) {
      return this.put(links.MAJORITY_CUSTOM_UPDATE(item.id), item);
    },
  },
};
